
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class ListTransition extends Vue {
    @Prop({default: {}})
    private listItem: any;
    private index = null;
    private imgs = [];
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    viewImage(item) {
        this.imgs = [item.ProductImage];
        this.index = 0;
    }
}
